export default __webpack_public_path__ + "static/media/logo.f9067069.png";